import React from 'react';
type Integration = {
  name: string;
  category: string;
};
const integrations: Integration[] = [{
  name: 'HubSpot',
  category: 'CRM'
}, {
  name: 'Salesforce',
  category: 'CRM'
}, {
  name: 'Pipedrive',
  category: 'CRM'
}, {
  name: 'GoHighLevel',
  category: 'CRM'
}, {
  name: 'Twilio',
  category: 'Voice & SMS'
}, {
  name: 'RingCentral',
  category: 'Voice & SMS'
}, {
  name: 'Calendly',
  category: 'Scheduling'
}, {
  name: 'Google Calendar',
  category: 'Scheduling'
}, {
  name: 'Cal.com',
  category: 'Scheduling'
}, {
  name: 'Facebook Lead Ads',
  category: 'Lead Source'
}, {
  name: 'Typeform',
  category: 'Lead Source'
}, {
  name: 'Zapier',
  category: 'Automation'
}];
function LogoTile({
  integration
}: {
  integration: Integration;
}) {
  return <div className="border border-gray-300 hover:border-navy-500 transition-colors bg-white rounded-xl h-20 flex flex-col items-center justify-center px-3 gap-1" data-id="element-152">
      <span className="italic text-sm text-gray-500 leading-none" data-id="element-153">
        {integration.name}
      </span>
      <span className="text-[10px] uppercase tracking-[0.1em] text-gray-400 font-semibold" data-id="element-154">
        {integration.category}
      </span>
    </div>;
}
export function Integrations() {
  return <section className="w-full border-b border-gray-200 bg-gray-50 px-4 sm:px-6 lg:px-12 py-10 sm:py-16 lg:py-20" data-id="element-155">
      <div className="mx-auto max-w-[1280px]" data-id="element-156">
        {/* Header */}
        <div className="flex flex-col items-center gap-3 text-center max-w-2xl mx-auto mb-8 sm:mb-10" data-id="element-157">
          <div className="text-[11px] uppercase tracking-[0.2em] text-gray-500 font-semibold" data-id="element-158">
            Works with your stack
          </div>
          <h2 className="text-2xl sm:text-2xl lg:text-3xl font-semibold text-gray-900 tracking-tight leading-tight" data-id="element-159">
            Plug into the tools you already use.
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-160">
            Native integrations with the CRMs, phone systems, calendars, and
            lead sources that service businesses run on.
          </p>
        </div>

        {/* Logo grid — 4 cols on mobile, 6 on desktop */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-161">
          {integrations.map(i => <LogoTile key={i.name} integration={i} data-id="element-162" />)}
        </div>

        {/* Footer line */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-2 text-center" data-id="element-163">
          <span className="text-sm text-gray-600" data-id="element-164">
            + 40 more integrations via Zapier and our REST API.
          </span>
          <span className="hidden sm:inline text-gray-400" data-id="element-165">·</span>
          <a href="#" className="text-sm font-medium text-gray-900 underline underline-offset-2 hover:text-gray-700" data-id="element-166">
            See all integrations →
          </a>
        </div>
      </div>
    </section>;
}